import { UniButton } from '@/design-system/components/buttons';
import { H6 } from '@/design-system/components/typography';
import { PageContainer } from '@/features/earn/components/page/PageContainer';
import { PageItem } from '@/features/earn/components/page/PageItem';
import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import React from 'react';
import { DevToolsPageHeader } from '../components/DevToolsPageHeader';
import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';

export const DevToolsGeneral: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.Main>> = ({ navigation }) => {
  return (
    <SafeAreaView sx={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <PageContainer sx={{ paddingX: '$10', paddingY: '$10', backgroundColor: 'transparent' }}>
          <DevToolsPageHeader currentPage={DevToolsStackRoutes.Main} />
          {/* <Divider /> */}
          <View sx={{ flex: 1, flexDirection: 'row', gap: '$5', width: '100%' }}>
            <PageItem sx={styles.pageItem}>
              <H6 bold>BottomSheet</H6>
              <UniButton label="Open BottomSheet" onPress={() => navigation.navigate(DevToolsStackRoutes.BottomSheet)} size="default" />
            </PageItem>
            <PageItem sx={styles.pageItem}>
              <H6 bold>Modal</H6>
              <UniButton label="Open Modal" onPress={() => navigation.navigate(DevToolsStackRoutes.Modal)} size="default" />
            </PageItem>
          </View>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {},
  pageItem: {
    width: 250,
    padding: '$7',
    borderRadius: 10,
    gap: '$2'
  }
};
